import './SummaryReport.scss';

interface BlueBoxProps {
    title: string | number;
    text: string
}

function BlueBox({ title, text }: BlueBoxProps) {
  return (
    <div className="blue-box__container">
      <div className="blue-box__text-container">
        <div className="blue-box__heading">{title}</div>
        <div className="blue-box__text">{text}</div>
      </div>
    </div>
  );
}

export default BlueBox;
